<template lang="pug">
div
  Soon
</template>

<script>
import Soon from '~/components/Soon';

export default {
  scrollToTop: true,
  meta: {
    theme: 'is-soon is-fixedHeader'
  },
  head: () => ({
    title: 'Soon'
  }),
  components: {
    Soon
  }
};
</script>
